import { render, staticRenderFns } from "./LeakageCauseLocationHouseQuestion.vue?vue&type=template&id=0fa2c9f2&scoped=true"
import script from "./LeakageCauseLocationHouseQuestion.vue?vue&type=script&lang=ts"
export * from "./LeakageCauseLocationHouseQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa2c9f2",
  null
  
)

export default component.exports